import { handleize } from "../helpers/utils";
class MainNavDesktop extends HTMLElement {
    config = null;
    categoryEl = null;
    constructor() {
        super();
        this.addEventListener("focusin", this.handleNavChange);
        this.addEventListener("mouseover", this.handleNavChange);
    }
    connectedCallback() {
        console.log("MainNavDesktop : connectedCallback");
        this.config = window.UTK_themeConfig?.mainNavigationDesktop ?? null;
        this.categoryEl = this.querySelector(".header__desktop-menu-list-sub-nav-container");
    }
    handleNavChange = (e) => {
        const target = e.target;
        const menuLinkOuterEl = target.classList.contains("menu-link-outer")
            ? target
            : target.closest(".menu-link-outer");
        if (menuLinkOuterEl) {
            const key = menuLinkOuterEl.getAttribute("data-key");
            const section = this.config?.sections.find((s) => handleize(s.title) === key);
            this.populateCategoryEl(section?.categories, section?.title);
        }
    };
    populateCategoryEl(categories, sectionTitle) {
        if (!this.categoryEl) {
            return;
        }
        if (categories?.length && sectionTitle) {
            this.categoryEl.classList.remove("hidden");
            this.categoryEl.innerHTML = `
        <ul class="header__desktop-menu-list-sub-nav" id="main-nav-desktop-subnav_${handleize(sectionTitle)}">
          ${categories.map((category) => `
              <li>
                <a id="main-nav-desktop-subnav-link_${handleize(sectionTitle)}_${handleize(category.title)}" class="header__desktop-menu-list-sub-nav-link" style="${category.color ? `color: ${category.color.value};` : ""}" href="${category.url}">${category.title}</a>
              </li>
            `).join("")}
        </ul>
      `;
        }
        else {
            this.categoryEl.classList.add("hidden");
            this.categoryEl.innerHTML = "";
        }
    }
}
if (!window.customElements.get("main-nav-desktop")) {
    customElements.define("main-nav-desktop", MainNavDesktop);
}
